import { metodiPagamentoMOCKUP } from "./paymentMethodsMock";

export function buildMetodiPagamentiMock() {
  return metodiPagamentoMOCKUP.map((m, idx) => {
    const associato = idx < 2;
    return {
      id: m.id,
      associato,
      descrizione: m.descrizione,
      urlLogo: m.logo,
    };
  });
}

